<section>
  <p>Iniciando sesión con Wise ID, espere un momento por favor...</p>
</section>
